import { useMemo, useState } from 'react';

import { useRecoilValue } from 'recoil';

import { useDraftFaxes } from 'lib/hooks/queries/fax/useDraftFaxes';

import { currentPractice } from 'components/practice/practiceState';
import AgTablePage from 'components/shared/AgTablePage/AgTablePage';

import SendFaxModal from '../components/SendFaxModal/SendFaxModal';

import { DEFAULT_FILTERS, getColDefs } from './lib/configs';

const DraftFaxes = () => {
  const currPractice = useRecoilValue(currentPractice);
  const timezone = currPractice?.timezone;
  const [sendFaxModalVisible, setSendFaxModalVisible] = useState(false);
  const [draftFax, setDraftFax] = useState(null);

  const columnDefs = useMemo(() => getColDefs(timezone), [timezone]);

  const onOpen = (fax) => {
    setSendFaxModalVisible(true);
    setDraftFax({ ...fax, tag_ids: fax?.tags });
  };

  const onRowClicked = (data) => {
    onOpen(data);
  };

  return (
    <>
      <AgTablePage
        defaultFilters={DEFAULT_FILTERS}
        defaultColumns={columnDefs}
        name="draft_faxes"
        queryKey="draftFaxes"
        title="Draft Faxes"
        useData={useDraftFaxes}
        rowStyle={{ cursor: 'pointer' }}
        disabledCells={['tagLinks']}
        onSelectRow={onRowClicked}
        noNewButton
      />
      {sendFaxModalVisible && (
        <SendFaxModal
          {...{ sendFaxModalVisible, setSendFaxModalVisible, faxData: draftFax, isDraft: true }}
        />
      )}
    </>
  );
};

export default DraftFaxes;
